import { apiDeleteInstallments, apiGetInstallments } from "api/installmentApi";
import TitleComponent from "./component/titleComponent";
import StatusComponent from "./component/statusComponent";
import { formatPrice } from "helpers";
import getCurrency from "helpers/currencyHelper";
import { searchType } from "forms/FactorForm";

interface TableData {
  title: string;
  key: string;
  type?: string;
  description?: string;
  label?: string;
  pluralLabel?: string;
  pageTitle?: string;
  pageDescription?: string;
  disableDateFilter?: boolean;
  tableColumns: TableColumn[];
  actions: { [key: string]: any };
}

interface TableColumn {
  name: string;
  key: string;
  filterParams?: {
    column?: string;
    columnType?: string;
  };
  searchType?: string;
  dataKey?: { label?: string; value?: number; id?: number }[];
  reqUrl?: string;
  Component?: React.ReactElement | any;
}

const defaultColumn = [
  {
    name: "عنوان",
    key: "description",
    Component: TitleComponent,
    searchType: "default",
    filterParams: {
      column: "description",
      columnType: "string",
    },
  },
  {
    name: "شخص",
    key: "personName",
    filterParams: {
      subColumn: "personName",
      columnType: "string",
    },
  },
  {
    name: "تاریخ پرداخت بعدی",
    key: "nextPaymentDate",
    filterParams: {
      subColumn: "nextPaymentDate",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "تعداد اقساط",
    key: "quantity",
    searchType: "default",
    filterParams: {
      column: "quantity",
      columnType: "string",
    },
  },
  {
    name: "مبلغ کل",
    key: "total",
    filterParams: {
      subColumn: "total",
      columnType: "string",
    },
    getValue: (item: any) =>
      `${formatPrice(item?.total || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "تسویه شده",
    key: "payed",
    filterParams: {
      subColumn: "payed",
      columnType: "string",
    },
    getValue: (item: any) =>
      `${formatPrice(item?.payed || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "مانده",
    key: "remaining",
    filterParams: {
      subColumn: "remaining",
      columnType: "string",
    },
    getValue: (item: any) =>
      `${formatPrice(item?.remaining || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
  },
  {
    name: "وضعیت",
    key: "status",
    Component: StatusComponent,
    // searchType: "status",
    // filterParams: {
    //   column: "status",
    //   columnType: "string",
    // },
    // dataKey: [
    //   { id: 1, label: "تسویه شده", value: 1 },
    //   { id: 2, label: "پرداخت ناقص", value: 0 },
    // ],
  },
];

export const installmentsTable: any = [
  {
    title: "دریافتی",
    description: "",
    key: "installmentReceive",
    type: "receive",
    label: "دریافتی",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: false,
    tableColumns: defaultColumn,
    actions: {
      edit: {},
      printInstallments: {},
      fetch: apiGetInstallments,
      delete: apiDeleteInstallments,
    },
  },
  {
    title: "پرداختی",
    description: "",
    key: "installmentPayment",
    type: "payment",
    label: "پرداختی",
    pageTitle: "",
    pageDescription: "",
    pluralLabel: "",
    disableDateFilter: false,
    tableColumns: defaultColumn,
    actions: {
      edit: {},
      fetch: apiGetInstallments,
      delete: apiDeleteInstallments,
    },
  },
];
